import { useNavigate, useOutletContext } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import EditModal from 'modules/reports/components/EditModal'
import type { RouteContextParams } from 'modules/reports/lib/RouterContextParams'

const DashboardEditModalPage = () => {
  const { navigation } = useNavigation()

  const navigate = useNavigate()
  const { dashboard } = useOutletContext<RouteContextParams>()

  return dashboard ? (
    <EditModal
      dashboard={dashboard}
      onClose={() =>
        navigate(
          navigation.reports.dashboards.dashboardId.list.fullPath({ dashboard_id: dashboard.id })
        )
      }
    />
  ) : null
}

export default DashboardEditModalPage
